import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Syntax highlighting - requires lexxy library
    // Uncomment when lexxy is available:
    // import { highlightAll } from "lexxy"
    // highlightAll()
  }
}
